import React, { useState, useEffect, useRef } from "react";
import SideDrawer from "./Drawer";
import {
  Box,
  Card,
  CardContent,
  Divider,
  makeStyles,
  Typography,
  Button,
  TextField,
  CircularProgress,
  Modal,
} from "@material-ui/core";
import { gpColors } from "../../constants/colors";
import { getCookie } from "../../Functions";
import CryptoAES from "crypto-js/aes";
import CryptoENC from "crypto-js/enc-utf8";
import AddProductValMOdal from "./AddProductValMOdal";
import DataTable from "react-data-table-component";
import Cookies from "js-cookie";
import api from "../Interceptors/axiosInstance";

const useStyles = makeStyles((theme) => ({
  roots: {
    width: "100%",
    display: "flex",
    height: "auto",
  },
  toolbar: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    backgroundColor: "#EAE4E8",
    flexGrow: 1,
    paddingTop: "84px",
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    height: "100%",
    width: "100%",
  },
  title: {
    fontSize: "20px",
    fontWeight: 600,
    paddingBottom: 20,
  },
  root: {
    //minWidth: 275,
    padding: "30px",
    minHeight: "280px",
    marginTop: "20px",
  },
  pos: {
    marginBottom: 12,
  },
  button: {
    textTransform: "none",
    backgroundColor: gpColors.logoBrown,
    color: "#fff",
    marginBottom: "12px",
    "&.MuiButtonBase-root": {
      "&:hover": { backgroundColor: gpColors.logoBrown },
    },
  },
  radioContainer: {
    display: "flex",
    flexDirection: "column",
    marginBottom: "30px",
    [theme.breakpoints.up("sm")]: {
      flexDirection: "row",
    },
  },
  uploadContainer: {
    display: "flex",
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  snackbar: {
    background: "green",
  },
  cardCont: {
    display: "flex",
    flexDirection: "column",
    alignItems: "normal",
    gap: "40px",
    [theme.breakpoints.down("sm")]: {
      padding: "0px",
    },
  },
  locTextFieldBox: {
    [theme.breakpoints.down("sm")]: {
      width: "70%",
    },
  },
  locListSearchBox: {
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      gap: "20px",
      padding: 0,
    },
  },
  searchBox: {
    [theme.breakpoints.down("sm")]: {
      justifyContent: "flex-start !important",
    },
  },
  shipToLOcTable: {
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      padding: "0 !important",
      marginTop: "10px",
    },
  },
  fieldBox: {
    width: "100%",
    "& .MuiOutlinedInput-root": {
      height: "40px",
      alignItems: "center",
    },
    "& .MuiInputBase-input": {
      padding: "14px",
    },
  },
  deleteLink: {
    color: "#F22F46",
    cursor: "pointer",
    textDecoration: "none",
    fontSize: "0.875rem",
    fontWeight: "bold",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  editLink: {
    color: "rgb(23, 94, 170)",
    cursor: "pointer",
    textDecoration: "none",
    fontSize: "0.875rem",
    fontWeight: "bold",
    "&:hover": {
      textDecoration: "underline",
    },
  },
}));

export const ShipToLoc = () => {
  const classes = useStyles();
  const [userData, setUserData] = useState({});
  const [loader, setLoader] = useState(false);
  const [location, setLocation] = useState("");
  const [search, setSearch] = useState("");
  const [locationData, setLocationData] = useState([]);
  const [locationId, setLocationId] = useState("");
  const [newLocation, setNewLocation] = useState("");
  const [alert, setAlert] = useState({
    alertStatus: false,
    alertMessage: "",
    alertColor: "",
  });
  const [open, setOpen] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const columns = [
    {
      name: "ID",
      // selector: (row, index) => index + 1,
      selector: (row, index) => (currentPage - 1) * rowsPerPage + index + 1,
      sortable: true,
      center: true,
      width: "20%",
    },
    {
      name: "Ship to Location",
      selector: (row) => row.location,
      sortable: true,
      center: true,
      width: "40%",
    },
    {
      name: "Action",
      width: "40%",
      cell: (row) => (
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            gap: 10,
          }}
        >
          <span
            className={classes.editLink}
            onClick={() => handleEditModal(row)}
          >
            Edit
          </span>
          <span
            className={classes.deleteLink}
            onClick={() => handleDeleteModal(row.id)}
          >
            Delete
          </span>
        </Box>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      center: true,
    },
  ];

  const handleDeleteModal = (locId) => {
    setOpen(true);
    setLocationId(locId);
  };
  const handleClose = () => setOpen(false);
  const handleEditClose = () => setOpenEdit(false);

  const handleDelete = async () => {
    handleClose();
    try {
      // const resp = await fetch(
      //   `${process.env.REACT_APP_API_ENDPOINT}/deleteLocationById?locationId=${locationId}`,
      //   {
      //     method: "POST",
      //     headers: {
      //       Authorization: `Token ${userData.loginInfo.data.jwt}`,
      //       "Content-Type": "application/json",
      //     },
      //   }
      // );
      const resp = await api.post(
        `/deleteLocationById?locationId=${locationId}`
      );

      const data = await resp.data;
      if (data.result === "success") {
        setAlert({
          ...alert,
          alertStatus: true,
          alertColor: "green",
          alertMessage: "Location Deleted successfully",
        });
        // setIsEditDelete(true);
        handleShowAllLocations();
      } else {
        setAlert({
          ...alert,
          alertStatus: true,
          alertColor: "red",
          alertMessage: "Something went wrong please try after sometime.",
        });
      }
    } catch (error) {
      setAlert({
        ...alert,
        alertStatus: true,
        alertColor: "red",
        alertMessage: "An error occurred while deleting the data.",
      });
    }
  };
  const handleEditSave = async () => {
    handleEditClose();
    setLoader(true);
    try {
      // const resp = await fetch(
      //   `${
      //     process.env.REACT_APP_API_ENDPOINT
      //   }/updateLocationById?locationId=${locationId}&location=${location.trim()}`,
      //   {
      //     method: "POST",
      //     headers: {
      //       // "ngrok-skip-browser-warning": "true",
      //       Authorization: `Token ${userData.loginInfo.data.jwt}`,
      //       "Content-Type": "application/json",
      //     },
      //   }
      // );
      const resp = await api.post(
        `/updateLocationById?locationId=${locationId}&location=${location.trim()}`
      );
      const data = await resp.data;
      setLoader(false);
      if (data.result === "success") {
        setAlert({
          ...alert,
          alertStatus: true,
          alertColor: "green",
          alertMessage: data.resultMessage || "Updated successfully",
        });
        handleShowAllLocations();
      } else {
        setAlert({
          ...alert,
          alertStatus: true,
          alertColor: "red",
          alertMessage:
            data.resultMessage ||
            "Something went wrong please try after sometime.",
        });
      }
      setLocation("");
    } catch (error) {
      setLoader(false);
      setAlert({
        ...alert,
        alertStatus: true,
        alertColor: "red",
        alertMessage: "An error occurred while editing the data.",
      });
    }
  };

  const handleEditModal = (item) => {
    console.log("item", item);
    setOpenEdit(true);
    setLocationId(item.id);
    setLocation(item.location);
  };
  // const getLoginInfoData = () => {
  //   const getValue = getCookie("guardPlus_user");
  //   if (getValue !== null) {
  //     const decryptedValue = CryptoAES.decrypt(getValue, "secretKey");
  //     const userVal = JSON.parse(decryptedValue.toString(CryptoENC));
  //     setUserData(userVal);
  //   }
  // };
  // const sessionUsername = Cookies.get("userName");
  const sessionUsername = sessionStorage.getItem("userName");
  const getLoginInfoData = () => {
    setUserData({ username: sessionUsername });
  };

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    getLoginInfoData();
  }, []);

  const handleLocationChange = (event) => {
    setLocation(event.target.value);
  };

  const handleAddLoc = async () => {
    if (location.trim() === "") {
      setAlert({
        alertStatus: true,
        alertColor: "red",
        alertMessage: "Please enter a location.",
      });
      return;
    }
    const textOnlyRegex = /^[A-Za-z\s]+$/;
    if (!textOnlyRegex.test(location.trim())) {
      setAlert({
        alertStatus: true,
        alertColor: "red",
        alertMessage: "Location must contain only letters and spaces.",
      });
      return;
    }
    setLoader(true);
    try {
      const resp = await api.post(`/add-ship-to-loc?loc=${location}`);
      const result = await resp.data;
      console.log("result: ", result);
      setLoader(false);
      if (result.result === "success") {
        setAlert({
          alertStatus: true,
          alertColor: "success",
          alertColor: "green",
          alertMessage: result.resultMessage,
        });
        setLocation("");
        handleShowAllLocations();
      } else {
        setAlert({
          alertStatus: true,
          alertColor: "error",
          alertColor: "red",
          alertMessage: result.resultMessage || "Failed to add location",
        });
      }
      setLocation("");
    } catch (error) {
      console.error("Error while adding location:", error);
      setLoader(false);
      setAlert({
        alertStatus: true,
        alertColor: "error",
        alertMessage: "An error occurred while adding the location.",
      });
    }
  };
  useEffect(() => {
    if (userData && Object.keys(userData).length > 0) {
      setLoader(true);
      handleShowAllLocations();
    }
  }, [userData]);

  const filteredData = locationData?.filter((item) =>
    item.location?.toLowerCase().includes(search.toLowerCase())
  );
  const [validationModal, setValidationModal] = useState(false);
  function closeValidationModal() {
    setValidationModal(false);
  }

  // Alert box close
  const handleAlertClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({
      ...alert,
      alertStatus: false,
      alertColor: "",
      alertMessage: "",
    });
  };

  const handleShowAllLocations = async () => {
    try {
      const response = await api.get("/get-all-ship-to-loc");
      const data = await response.data;

      if (data.result === "success" && Array.isArray(data.resultData)) {
        setLocationData(data.resultData);
      } else {
        setAlert({
          alertStatus: true,
          alertMessage: data.resultMessage,
          alertColor: "red",
        });
      }
      setLoader(false);
    } catch (e) {
      console.log(e);
      setAlert({
        alertStatus: true,
        alertMessage: "Failed to fetch locations. Please try after some time",
        alertColor: "red",
      });
      setLoader(false);
    }
  };
  return (
    <div className={classes.roots}>
      <SideDrawer tabName="shipToLoc" />
      <main className={classes.content}>
        <Typography className={classes.title}>Ship to Locations</Typography>
        <Divider />
        <Card className={classes.root}>
          <CardContent className={classes.cardCont}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "flex-start",
                gap: "30px",
              }}
            >
              <Box
                className={classes.locTextFieldBox}
                alignItems="left"
                sx={{ width: "30%" }}
              >
                <TextField
                  type="text"
                  variant="outlined"
                  value={location}
                  placeholder="Enter Ship to Location"
                  onChange={handleLocationChange}
                  className={classes.fieldBox}
                />
              </Box>
              <Button
                variant="contained"
                className={classes.submitButton}
                onClick={handleAddLoc}
              >
                Add
              </Button>
            </Box>
            {/* stock list  */}
            <Box>
              <Box
                className={classes.locListSearchBox}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  padding: "10px 20px 0 20px",
                }}
              >
                <Typography
                  style={{
                    fontSize: "22px",
                    fontWeight: 600,
                  }}
                >
                  Location List:
                </Typography>
                <Box
                  className={classes.searchBox}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-end",
                    alignItems: "center",
                  }}
                >
                  {/* Search Bar */}
                  <input
                    type="text"
                    placeholder="Search..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    style={{
                      marginBottom: "10px",
                      padding: "10px",
                      width: "300px",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                    }}
                  />
                </Box>
              </Box>
              <div
                className={classes.shipToLOcTable}
                style={{ padding: "20px" }}
              >
                {/* Data Table */}
                <DataTable
                  columns={columns}
                  data={filteredData || []}
                  progressPending={loader}
                  progressComponent={
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100px",
                      }}
                    >
                      <CircularProgress size={30} color="inherit" />
                    </div>
                  }
                  noDataComponent={
                    <div style={{ color: "red" }}>Data Not Exist</div>
                  }
                  pagination
                  paginationPerPage={rowsPerPage}
                  paginationRowsPerPageOptions={[5, 10, 20, 50, 100]}
                  onChangePage={(page) => setCurrentPage(page)}
                  onChangeRowsPerPage={(newPerPage) => {
                    setRowsPerPage(newPerPage);
                    setCurrentPage(1); 
                  }}
                  highlightOnHover
                  striped
                  responsive
                  persistTableHead
                  customStyles={{
                    headCells: {
                      style: {
                        backgroundColor: gpColors.logoGray,
                        color: "#fff",
                        fontWeight: "bold",
                        justifyContent: "center",
                      },
                    },
                    rows: {
                      style: {
                        fontSize: "0.875rem",
                      },
                    },
                  }}
                />
              </div>
            </Box>
          </CardContent>
        </Card>
      </main>
      <AddProductValMOdal
        validationModal={validationModal}
        closeValidationModal={closeValidationModal}
        handleAlertClose={handleAlertClose}
        alert={alert}
      />
      {/* Edit Modal */}
      <Modal
        open={openEdit}
        onClose={handleEditClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            borderRadius: 10,
            boxShadow: 24,
            p: 4,
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Typography
              id="modal-description"
              variant="body1"
              style={{ textAlign: "left" }}
            >
              Ship to Location
            </Typography>
            <TextField
              className={classes.input}
              variant="outlined"
              value={location}
              onChange={handleLocationChange}
              type="text"
            />
          </Box>
          <Box display="flex" justifyContent="center" mt={4}>
            <Button
              onClick={handleEditSave}
              style={{
                backgroundColor: "#F22F46",
                color: "#fff",
                width: "70%",
              }}
            >
              Update
            </Button>
          </Box>
        </Box>
      </Modal>
      {/* Delete Modal */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 600,
            bgcolor: "background.paper",
            borderRadius: 10,
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography
            id="modal-description"
            variant="body1"
            style={{ fontWeight: "bold" }}
          >
            Are you sure you want to delete this item?
          </Typography>
          <Typography
            id="warning-text"
            variant="body2"
            color="black"
            style={{ marginTop: "10px" }}
          >
            Note: Once this location is deleted, all associated scanned records
            will be archived and hidden from reports.
            {/* If needed in the future, you can restore the data by adding the same location name again. */}
          </Typography>
          <Box
            display="flex"
            justifyContent="flex-end"
            style={{ marginTop: "20px", gap: "20px" }}
          >
            <Button
              onClick={handleClose}
              style={{ backgroundColor: "rgb(54, 64, 75)", color: "#fff" }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleDelete}
              style={{ backgroundColor: "#F22F46", color: "#fff" }}
            >
              Delete
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};
